import { Component } from '@angular/core';
import { NavController, NavParams, Events, AlertController } from 'ionic-angular';

import { ImybookMarks } from '../../../models/myBookMarks';

@Component({
  selector: 'page-bookmarks',
  templateUrl: 'bookmarks.html'
})
export class Bookmarks {

  public bookmarks: ImybookMarks[];

  constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events, private alertController: AlertController) {
    this.bookmarks = navParams.data;
  }

  select(bookmark: ImybookMarks) {
  // debugger
    const confirm = this.alertController.create({
      title: 'Segnalibri',
      message: bookmark.excerpt,
      buttons: [
        {
          text: "chiudi",
          role: "cancel",
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        {
          text: "Vai",
          handler: data => {
            this.events.publish('select:location', bookmark.location);
            this.events.publish('booksDetailsModalShow', false);
          }
        }

      ]
    });
    confirm.present();
  }


  delete(bookmark: ImybookMarks) {

    const confirm = this.alertController.create({
      title: 'Conferma',
      message: " Vuoi eliminare questo Segnalibro",
      buttons: [
        {
          text: "annulla",
          role: "cancel",
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        {
          text: "Elimina",
          handler: data => {
            this.events.publish('delete:bookmark', bookmark)
            let index = this.bookmarks.map(bookmark => bookmark.location).indexOf(bookmark.location);
            this.bookmarks.splice(index, 1);
          }
        }
      ]
    });
    confirm.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/BOOK-READER/bookmarks/bookmarks.ts